import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import '../../../Static/Master/firmtable.css';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { deleteSchldata } from '../../../Store/PHPSlice/LocationApi';

const TableBody3 = ({
    serialNumber,
    id,
    schlNm,
    schlcd,
    zoneId,
    ph,
    adrs,
    zoneNm,
    userNm,
    pass,
    selected,
    handleClick,
}) => {
    const dispatch = useDispatch();
    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open

        window.open(`/school-edit/${id}`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const handleDeleteClick = () => {
        // Show confirmation dialog
        const isConfirmed = window.confirm("Are you sure you want to delete this Item?");

        // If user confirms, proceed with deletion
        if (isConfirmed) {
            dispatch(deleteSchldata(id))
                .then(() => {
                    // Reload the page to show updated results
                    toast("School Deleted Sucessfully");
                    window.location.reload();
                })
                .catch((error) => {
                    // Handle any errors that occur during the deletion process
                    console.error("Error deleting Item:", error);
                    toast.error("Failed to delete Item");
                });
        }
    };

    return (

        <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>

            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                {serialNumber}
            </TableCell>

            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                {schlNm}
            </TableCell>

            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                {schlcd}
            </TableCell>

            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                {ph}
            </TableCell>

            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                {adrs}
            </TableCell>

            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                {zoneNm}
            </TableCell>

            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                {userNm}
            </TableCell>

            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                {pass}
            </TableCell>

            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                <EditIcon className="cursor-pointer" onClick={handleEditClick} />
            </TableCell>
            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                <DeleteIcon className="cursor-pointer" onClick={handleDeleteClick} />
            </TableCell>


        </TableRow>

    );
};

export default TableBody3;
